export enum MatchTypeEnum {
  EXACT_MATCH = <any>'Exact',
  PARTIAL_MATCH = <any>'Partial',
  NO_MATCH = <any>'NoMatch'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/match-type.enum.ts